































































import { Component, Vue } from 'vue-property-decorator'
import { passwordValidator, checkPasswordValidator } from '../../utils/validator'
@Component
export default class ModifyPassword extends Vue {
  private showDialog: boolean = false
  private submitLoading: boolean = false
  private formData: any = {
    psw: '',
    newPsw: '',
    checkPsw: '',
  }
  private rules = {
    psw: [{ validator: passwordValidator, required: true, trigger: 'blur' }],
    newPsw: [{ validator: passwordValidator, required: true, trigger: 'blur' }],
    checkPsw: [{ validator: checkPasswordValidator(() => this.formData.newPsw), required: true, trigger: 'blur' }],
  }

  public show() {
    this.showDialog = true
  }
  public cancel() {
    this.showDialog = false
  }
  public submitForm(refName: string) {
    (this.$refs as any)[refName].validate().then(() => {
      console.log(222)
    })
  }
}
